import { configResponsive, useResponsive } from "ahooks"

configResponsive({
	xs: 480,
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200,
	"2xl": 1600,
})

export { useResponsive }
